<template>
  <form
    class="product-category-form uk-form-stacked"
    @submit.prevent="submit"
  >
    <!-- Basic Data -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend">{{$t('fieldsets.basicFields')}}</legend>

      <tenant-combobox
        v-if="showTenant"
        :label="$t('fields.tenant')"
        v-model="fields.values.tenant"
        :errors="fields.errors.tenant"
        :disabled="!isEditable"
      />

      <product-category-combobox
        v-else
        :label="$t('fields.parent')"
        v-model="fields.values.parent"
        :errors="fields.errors.parent"
        :filter="{ omittedIds: omittedParentIds }"
        :disabled="!isEditable"
      />

      <text-input
        ref="name"
        :label="$t('fields.name')"
        v-model="fields.values.name"
        :errors="fields.errors.name"
        :disabled="!isEditable"
      />

      <text-input
        :label="$t('fields.categoryNumber')"
        v-model="fields.values.categoryNumber"
        :errors="fields.errors.categoryNumber"
        :disabled="!isEditable"
      />
    </fieldset>

    <!-- SEO -->
    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend">{{$t('fieldsets.seo')}}</legend>

      <text-input
        :label="$t('fields.slug')"
        v-model="fields.values.slug"
        :errors="fields.errors.slug"
        :disabled="!isEditable"
        :placeholder="slugPlaceholder"
      />

      <readonly-form-field :label="$t('fields.path')">
        <span v-if="path">{{path}}</span>
        <text-placeholder v-else />
      </readonly-form-field>

      <keyword-list-input
        :label="$t('fields.aliases')"
        v-model="fields.values.aliases"
        :errors="fields.errors.aliases"
        :disabled="!isEditable"
      />
    </fieldset>

    <div class="uk-margin-medium-top">
      <submit-button type="primary" :disabled="!isSubmittable" />
      <cancel-button />
    </div>
  </form>
</template>

<script>
import omit from 'lodash/omit';
import CancelButton from '@/components/CancelButton';
import Form from '@/mixins/Form';
import KeywordListInput from '@/components/KeywordListInput';
import ProductCategoryCombobox from '@/components/ProductCategoryCombobox';
import slugQuery from '@/api/queries/slug.graphql';
import ReadonlyFormField from '@/components/ReadonlyFormField';
import SubmitButton from '@/components/SubmitButton';
import TenantCombobox from '@/components/TenantCombobox';
import TextInput from '@/components/TextInput';
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'product-category-form',
  mixins: [
    Form({
      tenant: { type: Form.Types.Reference },
      parent: { type: Form.Types.Reference },
      name: { required: true },
      aliases: { type: Form.Types.Array },
      slug: true,
      categoryNumber: true,
    }),
  ],

  props: {
    showTenant: Boolean,
    categoryId: Number,
  },
  components: {
    CancelButton,
    KeywordListInput,
    ProductCategoryCombobox,
    ReadonlyFormField,
    SubmitButton,
    TenantCombobox,
    TextInput,
    TextPlaceholder,
  },
  mounted() {
    this.$refs.name.focus();
  },
  computed: {
    path() {
      const segments = [];
      const parent = this.fields.values.parent;
      const slug = this.fields.values.slug || this.slugPlaceholder;
      if (parent) segments.push(parent.path);
      if (slug) segments.push(slug);
      return segments.join('/');
    },
    omittedParentIds() {
      if (!this.categoryId) return undefined;
      return [this.categoryId];
    },
  },
  apollo: {
    slugPlaceholder: {
      query: slugQuery,
      variables() {
        return { value: this.fields.values.name };
      },
      fetchPolicy: 'network-only',
      debounce: { wait: 500 },
      update({ slug }) {
        return slug;
      },
      skip() {
        return !this.fields.values.name;
      },
    },
  },
  methods: {
    dumpValues(values) {
      const dumpedValues = this.originalDumpValues(values);
      let omittedField;
      if (this.showTenant) {
        omittedField = 'parentId';
      } else {
        omittedField = 'tenantId';
      }
      return omit(dumpedValues, [omittedField]);
    },
  },
  i18n: {
    messages: {
      de: {
        fields: {
          parent: 'Übergeordnete Kategorie',
          tenant: 'Mandant',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductCategoryForm.vue?4aefbd25